package com.appcreator.client.firebase.functions

import com.appcreator.blueprint.firebase.functions.FirebaseFunctionsLoaderSpec
import com.appcreator.compose.di.Container
import com.appcreator.compose.extensions.JSEvaluationConfig

object FirebaseFunctionsInitializer {

    fun initialize(region: String, jsEvaluationConfig: JSEvaluationConfig) {

        Container.registerLoader(FirebaseFunctionsLoaderSpec::class) {
            FunctionsLoader(region, jsEvaluationConfig, it)
        }
    }
}

